import React, { useState } from 'react';
import './CalculatorPage.css';

function MobileNumberCompatibilityCalculator() {
  const [mobileNumber1, setMobileNumber1] = useState('');
  const [mobileNumber2, setMobileNumber2] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (num1, num2) => {
    // Placeholder for Mobile Number Compatibility calculation logic
    // This will need to be replaced with actual numerology logic
    if (!num1 || !num2) return null;

    const sumDigits = (number) => {
      let sum = 0;
      for (let i = 0; i < number.length; i++) {
        if (!isNaN(parseInt(number[i], 10))) {
          sum += parseInt(number[i], 10);
        }
      }
      while (sum > 9) {
        sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
      }
      return sum;
    };

    const compatibilityScore = (sumDigits(num1) + sumDigits(num2)) % 9 || 9; // Simple example
    return compatibilityScore;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!mobileNumber1 || !mobileNumber2) {
      setError('Please enter both mobile numbers.');
      return;
    }

    const calculated = calculate(mobileNumber1, mobileNumber2);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (score) => {
    return `Compatibility Score ${score}: This is a placeholder explanation for mobile number compatibility score ${score}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Mobile Number Compatibility Calculator",
    "description": "Check the compatibility between two mobile numbers using numerology.",
    "url": "https://www.yourwebsite.com/mobile-number-compatibility-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Mobile Number Compatibility",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/mobile-number-compatibility-calculator?num1={mobileNumber1}&num2={mobileNumber2}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=mobileNumber1",
        "required name=mobileNumber2"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Mobile Number Compatibility Calculator</h1>
      <p className="text-center">Enter two mobile numbers to check their numerological compatibility.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="mobileNumber1">Mobile Number 1:</label>
          <input
            type="text"
            id="mobileNumber1"
            className="form-control"
            value={mobileNumber1}
            onChange={(e) => setMobileNumber1(e.target.value)}
            placeholder="e.g., 9876543210"
          />
        </div>
        <div className="form-group">
          <label htmlFor="mobileNumber2">Mobile Number 2:</label>
          <input
            type="text"
            id="mobileNumber2"
            className="form-control"
            value={mobileNumber2}
            onChange={(e) => setMobileNumber2(e.target.value)}
            placeholder="e.g., 1234567890"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Compatibility</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Compatibility Score: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default MobileNumberCompatibilityCalculator;
